export default __webpack_public_path__ + "static/media/8-banner.4b44d1de.jpeg";